import React from 'react';
import { motion } from 'framer-motion';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function CoolingHire() {
  const features = ['Mobile AC systems', 'Evaporative technology', 'High-velocity air movers', 'Rapid crisis response', 'Always-on availability', 'Versatile deployment'];
  return <main className="flex-grow" data-id="element-382">
      <ServicePageHero title="Cooling Systems Hire" subtitle="Mobile air conditioning and ventilation units for rapid temperature reduction in commercial spaces." data-id="element-383" />

      <section className="py-20 bg-white" data-id="element-384">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-385">
          <div className="flex flex-col lg:flex-row-reverse gap-16 items-start" data-id="element-386">
            {/* Content Right (Alternated layout) */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-2/3" data-id="element-387">
              <h2 className="text-3xl font-heading font-bold text-brand-navy mb-6" data-id="element-388">
                Immediate Climate Relief
              </h2>

              <div className="space-y-6 text-brand-slate text-lg leading-relaxed mb-10" data-id="element-389">
                <p data-id="element-390">
                  We supply a broad spectrum of mobile cooling hardware
                  engineered to mitigate excessive heat across any facility
                  type. From compact data centers to expansive commercial
                  environments and industrial warehouses, our assets are prepped
                  for instant mobilization.
                </p>
                <p data-id="element-391">
                  Our inventory encompasses premium mobile air conditioning
                  units, robust evaporative coolers, and industrial-grade air
                  circulation fans. Whether the objective is safeguarding
                  sensitive IT infrastructure or maintaining safe working
                  conditions during extreme weather events, we provide the
                  appropriate technological solution.
                </p>
                <p data-id="element-392">
                  When thermal limits are breached unexpectedly, our crisis
                  response unit operates around the clock. We are capable of
                  transporting and configuring temporary cooling arrays across
                  the country, frequently within hours of initial contact,
                  thereby preventing operational downtime.
                </p>
                <p data-id="element-393">
                  Uncertain of the exact specifications required? Our technical
                  staff can perform swift evaluations to propose the most
                  efficient and cost-effective cooling methodology tailored to
                  your spatial constraints.
                </p>
              </div>

              <h3 className="text-xl font-heading font-bold text-brand-navy mb-6" data-id="element-394">
                Equipment Highlights
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-395">
                {features.map((feature, i) => <span key={i} className="bg-brand-light border border-gray-200 text-brand-navy px-4 py-2 rounded-full text-sm font-medium" data-id="element-396">
                    {feature}
                  </span>)}
              </div>
            </motion.div>

            {/* Sidebar Left */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/3 w-full sticky top-24" data-id="element-397">
              <div className="bg-brand-navy p-8 rounded-xl text-white mb-8" data-id="element-398">
                <h3 className="text-xl font-heading font-bold mb-4" data-id="element-399">
                  Quick Inquiry
                </h3>
                <p className="text-sm text-gray-400 mb-6" data-id="element-400">
                  Need cooling urgently? Call our 24/7 dispatch team.
                </p>
                <a href="tel:08004647025" className="block w-full text-center bg-brand-amber text-brand-navy font-bold py-3 rounded hover:bg-white transition-colors" data-id="element-401">
                  0800 464 7025
                </a>
              </div>
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2025/04/200kW-AHU.webp" alt="Air Handling Unit" className="rounded-xl shadow-lg w-full object-cover" data-id="element-402" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Other Services Strip */}
      <section className="bg-brand-light py-8 border-y border-gray-200" data-id="element-403">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-404">
          <span className="text-brand-slate font-medium" data-id="element-405">Explore more:</span>
          <Link to="/chiller-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-406">
            Industrial Chillers
          </Link>
          <Link to="/heater-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-407">
            Portable Heaters
          </Link>
          <Link to="/ancillaries" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-408">
            Ancillary Equipment
          </Link>
        </div>
      </section>

      <CTASection data-id="element-409" />
    </main>;
}